import { State } from 'modules';

export const getActiveOverlay = (state: State): string => state.ui.overlay;



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/overlays.ts